<template>
  <div class="lease-inclusion-container row q-my-xl">
    <div class="lease-inclusion-content" v-for="(leaseInclusion, index) in leaseInclusionIcons" :key="`leaseInclusion_${index}`">
      <div class="lease-inclusion-icon">
        <MainIcon :icon="leaseInclusion.icon" :size="'large'" />
      </div>
      <p class="lease-inclusion-label q-mt-sm text-grey-8 font-nunito">
        {{ leaseInclusion.label }}
      </p>
    </div>
  </div>
</template>

<script>
import { LeaseInclusionIdentifierMixin } from '../../../mixins/calculator';
import MainIcon from '../Icon/Inclusion/MainIcon.vue';
export default {
  name: 'LeaseInclusionVehicleResult',
  mixins: [LeaseInclusionIdentifierMixin],
  components: {
    MainIcon
  }
};
</script>

<style lang="sass" scoped>
.lease-inclusion-container
  gap: 10px
  justify-content: center

.lease-inclusion-content
  width: 150px
  display: flex
  flex-flow: column wrap
  align-items: center
  text-align: center
  .lease-inclusion-icon
    width: 80px
    height: 60px
.lease-inclusion-label
  font-weight: 600
</style>
